/*
 * Colors V4.0
 */
export const F1 = '#2c2c2c';
export const F2 = '#565656';
export const B2 = '#00aeef';
export const B3 = '#172d72';
export const B4 = '#f7f8f9';
export const T1 = '#69c384';
export const T3 = '#ee6d85';
export const T7 = '#e30c34';

/*
 * Colors V3.0
 * https://lanhuapp.com/url/s6nf5-Rszx3
 */
export const M1 = '#ffffff';
export const M2 = '#f7f8f9';
export const B1 = '#be1d32';
export const T2 = '#e9eaee';
export const T4 = '#7d3f98';
export const T5 = '#f8c200';
export const T6 = '#f15a24';

/*
 * Colors V2.0
 */
export const C2 = '#d9d9d9';
export const C4 = '#999999';

const all = {
  M1,
  M2,
  F1,
  F2,
  B1,
  B2,
  B3,
  B4,
  T1,
  T2,
  T3,
  T4,
  T5,
  T6,
  T7,
  C2,
  C4,
};

export const VI = {
  ...all,
  B5: '#ce9f37',
  B6: '#190f4b',
  B7: '#4f38c3',
};

export const AntD = {
  warning: '#faad14',
  error: '#ff4d4f',
};
